import { Component, TemplateRef, input, model } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-appointment-type-dialog',
  templateUrl: './appointment-type-dialog.component.html',
  standalone: false,
})
export class AppointmentTypeDialogComponent {
  // Inputs
  public appointmentTypeForm = model.required<FormGroup>();
  readonly footer = input.required<TemplateRef<any>>();
}
